import ApiService from "@/core/services/api.service";
import { STATUS_CODE } from "@/core/config/constant";
import { SET_ERROR } from "@/core/services/store/auth.module";
// mutation types
export const GET_LIST_TRANSACTION = "getListTransaction";
export const GET_LIST_TRANSACTION_V2 = "getListTransactionV2";
export const SET_LIST_TRANSACTION = "setListTransaction";
export const SET_LIST_TRANSACTION_V2 = "setListTransactionV2";
export const LIST_TRANSACTION = "listTransaction";
export const LIST_TRANSACTION_V2 = "listTransactionV2";
export const LIST_TRANSACTION_V3 = "listTransactionV3";
export const LIST_BUDGET_PRE_COMPARISION = "listBudgetPreComparision";
const { SUCCESS, BAD_REQUEST } = STATUS_CODE;
export const SET_STATUS = "SetStatus"
export const SET_ERROR_MESSAGE = "SetErrorMessage"


const state = {
    listTransaction: {
        listDataByDate: {},
        listJimukanri: []
    },
    listTransactionV2: {},
    errors: null,
    status: null
};

const getters = {
    getListTransaction: state => state.listTransaction.listDataByDate,
    getListTransactionV2: state => state.listTransactionV2,
    getListTitle: state => state.listTransaction.listJimukanri,
    ForecastStatus: state => state.status,
    ForecastErrors: state => state.errors
};


const mutations = {
    [SET_LIST_TRANSACTION](state, listTransaction) {
        state.listTransaction = listTransaction;
    },
    [SET_LIST_TRANSACTION_V2](state, listTransaction) {
        state.listTransactionV2 = listTransaction;
    },
    [SET_STATUS](state, code) {
        state.status = code;
    },
    [SET_ERROR_MESSAGE](state, errors) {
        state.errors = errors
    }
};


const actions = {
    async [LIST_TRANSACTION](context, time) {
        context.commit(SET_STATUS, null)
        context.commit(SET_ERROR_MESSAGE, null)
        context.commit(SET_LIST_TRANSACTION, {
            listDataByDate: {},
            listJimukanri: []
        })
        try {
            const response = await ApiService.post('forecast/list-transaction-by-time', time)
            if (response.data.code == SUCCESS) {
                context.commit(SET_LIST_TRANSACTION, response.data.data);
                context.commit(SET_STATUS, response.data.code)
            }
            if (response.data.code == BAD_REQUEST) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, response.data.data)
            }
        } catch (e) {
            if (e.response.data.code == ERROR_SERVER) {
                context.commit(SET_ERROR, e.response.data.message);
                throw e.response.data.message
            } else {
                throw e;
            }
        }

    },
    async [LIST_TRANSACTION_V2](context, time) {
        context.commit(SET_STATUS, null)
        context.commit(SET_ERROR_MESSAGE, null)
        context.commit(SET_LIST_TRANSACTION, {
            listDataByDate: {},
            listJimukanri: []
        })
        return new Promise((resolve) => {
            ApiService.post('forecast/list-transaction-by-time-v2', time)
              .then(({ data }) => {
                  resolve(data);
              })
              .catch(e  => {
                  throw e;
              });
        });

    },
    async [LIST_TRANSACTION_V3](context, time) {
        context.commit(SET_STATUS, null)
        context.commit(SET_ERROR_MESSAGE, null)
        context.commit(SET_LIST_TRANSACTION, {
            listDataByDate: {},
            listJimukanri: []
        })
        return new Promise((resolve) => {
            ApiService.post('forecast/list-transaction-by-time-v3', time)
              .then(({ data }) => {
                  resolve(data);
              })
              .catch(e  => {
                  throw e;
              });
        });

    },
    async [LIST_BUDGET_PRE_COMPARISION](context, time) {
        return new Promise((resolve) => {
            ApiService.post('forecast/budget-pre-comparision-report-v2', time)
              .then(({ data }) => {
                  resolve(data);
              })
              .catch(e  => {
                  throw e;
              });
        });

    },
}



export default {
    state,
    actions,
    mutations,
    getters
};
